import { Link } from "react-router-dom";
import { images } from "../../config/images";
import { siteContent } from "../../content/siteContent";
import { ResponsiveImage } from "./ResponsiveImage";

export function HomeFooter() {
  const { footer } = siteContent;
  const year = new Date().getFullYear();

  return (
    <footer className="home-footer">
      <div className="home-shell">
        <div className="home-footer__top">
          <div className="home-footer__brand-block">
            <Link to="/" aria-label="Evolution by Corina, volver al inicio">
              <ResponsiveImage image={images.logo} className="home-footer__logo" />
            </Link>
            <p>{footer.tagline}</p>
          </div>

          <nav className="home-footer__nav" aria-label={footer.navigationLabel}>
            {footer.links.map((link) =>
              link.href.startsWith("#") ? (
                <a key={link.href} href={link.href}>
                  {link.label}
                </a>
              ) : (
                <Link key={link.href} to={link.href}>
                  {link.label}
                </Link>
              ),
            )}
          </nav>

          <div className="home-footer__social">
            <p>Social</p>
            <span>{footer.socialLabel}</span>
          </div>
        </div>

        <div className="home-footer__bottom">
          <p>© {year} Evolution by Corina</p>
          <p>{footer.legalNote}</p>
        </div>
      </div>
    </footer>
  );
}
